import { LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { ExtraOptions, PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { ToastrModule } from "ngx-toastr";

import { CoreModule } from "@core/core.module";
import { CoreCommonModule } from "@core/common.module";
import { CoreSidebarModule, CoreThemeCustomizerModule } from "@core/components";

import { coreConfig } from "app/app-config";

import { AppComponent } from "app/app.component";
import { LayoutModule } from "app/layout/layout.module";
import { SharedModule } from "app/shared/shared.module";
import { NgxPaginationModule } from "ngx-pagination";

import { CPFPipe } from "app/shared/cpf-pipe/cpf.pipe";
import { UsuarioComponent } from './main/pages/usuario/usuario.component';
import { PagesModule } from "./main/pages/pages.module";
import { appRoutes } from 'app/app.routing';
import { AuthInterceptor } from "./auth/helpers/auth.interceptor";
import { AuthGuard } from "./auth/helpers";
import { NgxMaskModule } from 'ngx-mask';

const routerConfig: ExtraOptions = {
	preloadingStrategy: PreloadAllModules,
	scrollPositionRestoration: 'enabled'
};

registerLocaleData(localePt);

@NgModule({
	declarations: [AppComponent, CPFPipe, UsuarioComponent],
	imports: [
		BrowserModule,
		NgxPaginationModule,
		BrowserAnimationsModule,
		HttpClientModule,
		RouterModule.forRoot(appRoutes, routerConfig),
		TranslateModule.forRoot(),
		PagesModule,
		NgbModule,
		ToastrModule.forRoot(),
		CoreModule.forRoot(coreConfig),
		CoreCommonModule,
		CoreSidebarModule,
		CoreThemeCustomizerModule,
		LayoutModule,
		SharedModule,
		NgxMaskModule.forRoot()
	],
	providers: [{ provide: LOCALE_ID, useValue: 'pt-BR' }, {
		provide: HTTP_INTERCEPTORS,
		useClass: AuthInterceptor,
		multi: true,
	  },AuthGuard],
	bootstrap: [AppComponent],
})
export class AppModule { }